import { Component, OnInit } from '@angular/core';
import { FieldMetaData, NeskoAbDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ContentHeaderComponent } from '../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { KompaktNeskoabGrundstueckComponent } from '../../shared/kompaktdarstellung/neskoab/kompakt-neskoab-grundstueck.component';
import { KopfdatenelementComponent } from '../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { NeskoAmtlicheBewertungComponent } from './nesko-amtliche-bewertung/nesko-amtliche-bewertung.component';
import { ObjekteComponent } from './objekte/objekte.component';
import { RubrikComponent } from '../../shared/components/rubrik/rubrik.component';
import { NeskoabGrundstueckEigentumComponent } from './neskoab-grundstueck-eigentum/neskoab-grundstueck-eigentum.component';
import { NeskoabPersonenEigentumComponent } from './neskoab-personen-eigentum/neskoab-personen-eigentum.component';
import { NeskoabNutzniesserComponent } from './neskoab-nutzniesser/neskoab-nutzniesser.component';
import { TranslateNamePipe } from '../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-neskoab-detail',
  templateUrl: './neskoab-detail.component.html',
  styleUrls: ['./neskoab-detail.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    KompaktNeskoabGrundstueckComponent,
    KopfdatenelementComponent,
    NeskoAmtlicheBewertungComponent,
    ObjekteComponent,
    RubrikComponent,
    NeskoabGrundstueckEigentumComponent,
    NeskoabPersonenEigentumComponent,
    NeskoabNutzniesserComponent,
    TranslatePipe,
    TranslateNamePipe
  ]
})
export class NeskoabDetailComponent extends AbstractComponent implements OnInit {
  neskoEntry: NeskoAbDetailEntryMeta;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.addSub(
      this.route.data.subscribe((data) => {
        this.neskoEntry = data.entity;
      })
    );
    this.addSub(
      this.translate.onLangChange.subscribe(() => {
        this.router.navigate(['./'], {
          relativeTo: this.route,
          queryParams: {
            gemeindeId: this.route.snapshot.queryParams['gemeindeId'],
            nummer: this.route.snapshot.queryParams['nummer'],
            nummer2: this.route.snapshot.queryParams['nummer2'],
            nummer3: this.route.snapshot.queryParams['nummer3']
          }
        });
      })
    );
  }

  get gsNummer(): string {
    let nummer = this.neskoEntry.nummer;
    if (this.neskoEntry.nummer2 !== '0' || this.neskoEntry.nummer3 !== '0') {
      nummer += '-' + this.neskoEntry.nummer2;
    }
    if (this.neskoEntry.nummer3 !== '0') {
      nummer += '-' + this.neskoEntry.nummer3;
    }
    return nummer;
  }

  get hasRightObjekte(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mObjekte.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightVerteiler(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mVerteiler.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightNutzniessung(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mNutzniesser.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightAmtlicherWert(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mAmtlicherWert.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightEigentum(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mEigentum.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }
}
